import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.dashlets.UnreadMessages';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class UnreadMessages extends RpcClass{

    /**
     *  @class UnreadMessages
     *  @alias module:src/server/com/silkplm/dashlets/UnreadMessages.UnreadMessages
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param entityId {string} 
     * @param inquiryType {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Date>}
     */
     getInstantOfLastUpdatedMessageBase(entityId, inquiryType) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/dashlets/unread-messages/get-instant-of-last-updated-message-base', [entityId, inquiryType]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = new Date(rawValue)
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param entityId {string} 
     * @param inquiryType {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Date>}
     */
     getInstantOfLastUpdatedMessageInquiry(entityId, inquiryType) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/dashlets/unread-messages/get-instant-of-last-updated-message-inquiry', [entityId, inquiryType]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = new Date(rawValue)
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param entityId {string} 
     * @param inquiryType {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     updateOrInsertMessageStateInBase(entityId, inquiryType) {
            return RpcClass.rpcCall('/rpc/dashlets/unread-messages/update-or-insert-message-state-in-base', [entityId, inquiryType]);
    }
    /** 
     * @async
     * @param entityId {string} 
     * @param inquiryType {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     updateOrInsertMessageStateInInquiry(entityId, inquiryType) {
            return RpcClass.rpcCall('/rpc/dashlets/unread-messages/update-or-insert-message-state-in-inquiry', [entityId, inquiryType]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.dashlets.UnreadMessages';
metadata.__type_short__ = 'UnreadMessages';
UnreadMessages.prototype.__metadata__ = metadata;

UnreadMessages.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/dashlets/UnreadMessages */
export default UnreadMessages

export { UnreadMessages }
